/* eslint-disable camelcase */
// TODO not complete. Can be finished with swagger schema

export type ArticleDto = {
    id: string;
    entity_type: string;
    title: string;
    subtitle?: string;
    strapline?: string;
    body: Body[];
    published_at: string;
    published_until?: string;
    status: 'active' | 'inactive';
    type: 'news' | 'interview' | 'commentary' | 'analysis' | 'report';
    live: boolean;
    important: boolean;
    comments: Comments;
    run_ads: boolean;
    view_counter: number;
    custom_author: string;
    image: Image;
    adult_content: boolean;
    generic?: any;
    urls: UrlsShort;
    seo: Seo;
    created_at: string;
    updated_at: string;
    category: Category;
    additional_categories: AdditionalCategory[];
    authors: Author[];
    main_media: MainMedia[];
    created_by: CreatedBy;
};

export type Body = {
    data: any;
    type: string;
};

export const BodyNodeType = {
    Embed: 'embed',
    Image: 'image',
    EditorBlock: 'editor_block',
};
export type BodyNodeType = typeof BodyNodeType[keyof typeof BodyNodeType];

export const HTMLEmbedType = {
    Video: 'video',
};
export type HTMLEmbedType = typeof HTMLEmbedType[keyof typeof HTMLEmbedType];

export type GenericLinkDto = {
    superbetMatchId?: string;
    superbetTournamentId?: string;
    socialUserID?: string;
};

type Comments = {
    allow: boolean;
    collection_id?: any;
};

type Owner = {
    id?: any;
    name?: any;
};

type Data = {
    id: string;
    entity_type: string;
    description?: any;
    type: string;
    urls: DataUrls;
    path: string;
    generic?: any;
    created_at: string;
    updated_at: string;
    owner: Owner;
    created_by: CreatedBy;
};

type Image = {
    data: Data;
    description?: any;
};

type UrlsShort = {
    live_url?: string;
    external_url?: string;
    canonical_url?: string;
};

type CategorySub = {
    id: string;
    entity_type: string;
    title: string;
    description?: any;
    active: boolean;
    parent_id: string;
    generic?: any;
    seo: Seo;
    urls: Urls;
    created_at: string;
    updated_at: string;
    subs: any[];
    main_media: any[];
    created_by: CreatedBy;
};

type Category = {
    id: string;
    entity_type: string;
    title: string;
    description?: any;
    active: boolean;
    parent_id?: any;
    generic?: any;
    seo: Seo;
    urls?: any;
    created_at: string;
    updated_at: string;
    subs: CategorySub[];
    main_media: any[];
    created_by: CreatedBy;
};

type Seo = {
    title?: string;
    description?: any;
    slug?: string;
    keywords?: string[];
    index?: boolean;
    follow?: boolean;
    redirect_type?: 'temporary' | 'permanent';
};

type Urls = {
    external_url?: any;
    canonical_url?: any;
};

type AdditionalCategorySub = {
    id: string;
    entity_type: string;
    title: string;
    description?: any;
    active: boolean;
    parent_id: string;
    generic?: any;
    seo: Seo;
    urls: Urls;
    created_at: string;
    updated_at: string;
    subs: any[];
    main_media: any[];
    created_by: CreatedBy;
};

type AdditionalCategory = {
    id: string;
    entity_type: string;
    title: string;
    description?: string;
    active: boolean;
    parent_id?: string;
    generic?: any;
    seo: Seo;
    urls?: any;
    created_at: string;
    updated_at: string;
    subs: AdditionalCategorySub[];
    main_media: any[];
    created_by: CreatedBy;
};

type Author = {
    id: string;
    entity_type: string;
    name: string;
    bio?: any;
    active: boolean;
    default: boolean;
    avatar_url?: any;
    generic?: any;
    created_at: string;
    updated_at: string;
    created_by: CreatedBy;
};

type Uploaded = {
    embed: string;
    gallery: string;
    original: string;
    thumbnail: string;
};

type ImageInfo = {
    top: number;
    left: number;
    right: number;
    bottom: number;
} | {
    top: undefined;
    left: undefined;
    right: undefined;
    bottom: undefined;
};

type DataUrls = {
    '16x9': ImageInfo;
    cropped?: unknown;
    uploaded: Uploaded;
    '4x3': ImageInfo;
    '2x3': ImageInfo;
};

type MainMedia = {
    resource_id?: string;
    resource_type?: 'image' | 'video' | 'gallery' | 'widget' | 'embed';
    resource_subtype?: 'default' | 'main_image' | 'vertical_image' | 'eye_catcher' | 'odds' | 'compare_odds'
    | 'player_profile' | 'team_profile' | 'standings' | 'match' | 'fixtures' | 'top_scorers' | 'team_players';
    provider: 'smp' | 'external';
    description: string;
    data: FreeformJSON;
};

type CreatedBy = {
    id?: undefined;
    full_name?: undefined;
} | {
    id: string;
    full_name: string;
};

type FreeformJSON = {
    [key: string]: string | number | undefined | null | FreeformJSON;
};
